const DEPRECATED_REACT_PROPS = {};
export { DEPRECATED_REACT_PROPS };

//# sourceMappingURL=deprecated-react-props.js.map